import { Routes } from '@angular/router';
import { isAuthenticatedGuard } from './core/auth/guards/is-authenticated-guard';
import { accountManagerSiteSelectionGuard } from './core/auth/guards/account-manager-site-selection.guard';

export const routes: Routes = [
  {
    title: 'Dashboard',
    path: 'dashboard',
    canActivate: [accountManagerSiteSelectionGuard],
    loadComponent: () => import('./views/dashboard/dashboard.component').then((c) => c.DashboardComponent),
  },
  {
    title: 'Properties',
    path: 'properties',
    canActivate: [isAuthenticatedGuard, accountManagerSiteSelectionGuard],
    loadChildren: () => import('./views/properties/properties.routes').then((r) => r.routes),
  },
  {
    title: 'New Developments',
    path: 'developments',
    canActivate: [isAuthenticatedGuard, accountManagerSiteSelectionGuard],
    loadChildren: () => import('./views/properties/properties.routes').then((r) => r.routes),
  },
  {
    title: 'Calendar',
    path: 'calendar',
    canActivate: [isAuthenticatedGuard, accountManagerSiteSelectionGuard],
    loadChildren: () => import('./views/calendar/calendar.routes').then((r) => r.routes),
  },
  {
    title: 'Office',
    path: 'office',
    canActivate: [isAuthenticatedGuard, accountManagerSiteSelectionGuard],
    loadChildren: () => import('./views/office/office.routes').then((r) => r.routes),
  },
  {
    title: 'Settings',
    path: 'settings',
    canActivate: [isAuthenticatedGuard],
    loadChildren: () => import('./views/settings/settings.routes').then((r) => r.routes),
  },
  {
    title: 'Admin Portal',
    path: 'admin',
    canActivate: [isAuthenticatedGuard],
    loadChildren: () => import('./views/admin/admin.routes').then((r) => r.routes),
  },
  {
    title: 'Not Found',
    path: 'not-found',
    loadComponent: () => import('./views/page-not-found/page-not-found.component').then((c) => c.PageNotFoundComponent),
  },
  {
    title: 'Invitation',
    path: 'invitation',
    loadComponent: () => import('./views/invitation/invitation.component').then((c) => c.InvitationComponent),
  },
  {
    title: 'Unauthorized',
    path: 'unauthorized',
    loadComponent: () => import('./views/page-not-found/page-not-found.component').then((c) => c.PageNotFoundComponent),
  },
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: '**', redirectTo: 'not-found' },
];
